export default __webpack_public_path__ + "static/media/shopini.3983af0f.svg";